import type { AspidaClient, BasicHeaders } from 'aspida';
import { dataToURLString } from 'aspida';
import type { Methods as Methods_10i7gxn } from './v1/gachas';
import type { Methods as Methods_qpdg6l } from './v1/gachas/_gachaId@string';
import type { Methods as Methods_n3ydjs } from './v1/gachas/_gachaId@string/delivery_bundles';
import type { Methods as Methods_18h6bkn } from './v1/gachas/_gachaId@string/orders';
import type { Methods as Methods_i3lft1 } from './v1/gachas/_gachaId@string/payment_methods';
import type { Methods as Methods_1k90ym3 } from './v1/gachas/_gachaId@string/prize_categories';
import type { Methods as Methods_155ooz } from './v1/gachas/_gachaId@string/prizes';
import type { Methods as Methods_jp7gs4 } from './v1/gachas/by/unique_name/_uniqueName@string';
import type { Methods as Methods_rtn983 } from './v1/gift_codes';
import type { Methods as Methods_fqs2dy } from './v1/me';
import type { Methods as Methods_lqx827 } from './v1/me/areas';
import type { Methods as Methods_14pl3r8 } from './v1/me/beacons';
import type { Methods as Methods_ffqwfn } from './v1/me/credits';
import type { Methods as Methods_u3w4jc } from './v1/me/credits/_cardSeqId@string';
import type { Methods as Methods_3ypo3e } from './v1/me/granted_prizes';
import type { Methods as Methods_95zgw7 } from './v1/me/granted_prizes/benefits/_benefitPrizeId@string/download';
import type { Methods as Methods_12oioyj } from './v1/me/granted_prizes/prizes/_prizeId@string/download';
import type { Methods as Methods_1c0gekd } from './v1/me/icons/upload';
import type { Methods as Methods_19tp65g } from './v1/me/infos';
import type { Methods as Methods_ixueji } from './v1/me/ocodes';
import type { Methods as Methods_rok7wn } from './v1/me/prize_tickets';
import type { Methods as Methods_jnwdhc } from './v1/me/prize_tickets/_serial_code@string';
import type { Methods as Methods_1p1uf81 } from './v1/orders';
import type { Methods as Methods_uv94x9 } from './v1/orders/_orderId@string';
import type { Methods as Methods_15gem2t } from './v1/orders/_orderId@string/payments';
import type { Methods as Methods_1e8vwug } from './v1/orders/_orderId@string/payments/alipay';
import type { Methods as Methods_16asjng } from './v1/orders/_orderId@string/payments/applepay';
import type { Methods as Methods_c5df96 } from './v1/orders/_orderId@string/payments/carriers/au';
import type { Methods as Methods_nf65lj } from './v1/orders/_orderId@string/payments/carriers/docomo';
import type { Methods as Methods_ouaef2 } from './v1/orders/_orderId@string/payments/carriers/softbank';
import type { Methods as Methods_1g1qew3 } from './v1/orders/_orderId@string/payments/credit';
import type { Methods as Methods_1fmwd6u } from './v1/orders/_orderId@string/payments/credit/3ds2';
import type { Methods as Methods_nvzj09 } from './v1/orders/_orderId@string/payments/googlepay';
import type { Methods as Methods_801cq2 } from './v1/orders/_orderId@string/payments/play_tickets';
import type { Methods as Methods_15ezvix } from './v1/orders/_orderId@string/payments/unionpay';
import type { Methods as Methods_1n5lpfq } from './v1/payments/apple_pay_session';
import type { Methods as Methods_a3nfz1 } from './v1/pickups';
import type { Methods as Methods_1r1cra4 } from './v1/play_tickets';
import type { Methods as Methods_ei2tgm } from './v1/redeem_tickets';
import type { Methods as Methods_1rwgf4h } from './v1/users/signup';

const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? '' : baseURL).replace(/\/$/, '');
  const PATH0 = '/v1/gachas';
  const PATH1 = '/delivery_bundles';
  const PATH2 = '/orders';
  const PATH3 = '/payment_methods';
  const PATH4 = '/prize_categories';
  const PATH5 = '/prizes';
  const PATH6 = '/v1/gachas/by/unique_name';
  const PATH7 = '/v1/gift_codes';
  const PATH8 = '/v1/me';
  const PATH9 = '/v1/me/areas';
  const PATH10 = '/v1/me/beacons';
  const PATH11 = '/v1/me/credits';
  const PATH12 = '/v1/me/granted_prizes';
  const PATH13 = '/v1/me/granted_prizes/benefits';
  const PATH14 = '/download';
  const PATH15 = '/v1/me/granted_prizes/prizes';
  const PATH16 = '/v1/me/icons/upload';
  const PATH17 = '/v1/me/infos';
  const PATH18 = '/v1/me/ocodes';
  const PATH19 = '/v1/me/prize_tickets';
  const PATH20 = '/v1/orders';
  const PATH21 = '/payments';
  const PATH22 = '/payments/alipay';
  const PATH23 = '/payments/applepay';
  const PATH24 = '/payments/carriers/au';
  const PATH25 = '/payments/carriers/docomo';
  const PATH26 = '/payments/carriers/softbank';
  const PATH27 = '/payments/credit';
  const PATH28 = '/payments/credit/3ds2';
  const PATH29 = '/payments/googlepay';
  const PATH30 = '/payments/play_tickets';
  const PATH31 = '/payments/unionpay';
  const PATH32 = '/v1/payments/apple_pay_session';
  const PATH33 = '/v1/pickups';
  const PATH34 = '/v1/play_tickets';
  const PATH35 = '/v1/redeem_tickets';
  const PATH36 = '/v1/users/signup';
  const GET = 'GET';
  const POST = 'POST';
  const PUT = 'PUT';
  const DELETE = 'DELETE';
  const PATCH = 'PATCH';

  return {
    v1: {
      gachas: {
        _gachaId: (val2: string) => {
          const prefix2 = `${PATH0}/${val2}`;

          return {
            delivery_bundles: {
              get: (option: { query: Methods_n3ydjs['get']['query'], headers: Methods_n3ydjs['get']['reqHeaders'], config?: T | undefined }) =>
                fetch<Methods_n3ydjs['get']['resBody']>(prefix, `${prefix2}${PATH1}`, GET, option).json(),
              $get: (option: { query: Methods_n3ydjs['get']['query'], headers: Methods_n3ydjs['get']['reqHeaders'], config?: T | undefined }) =>
                fetch<Methods_n3ydjs['get']['resBody']>(prefix, `${prefix2}${PATH1}`, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_n3ydjs['get']['query'] } | undefined) =>
                `${prefix}${prefix2}${PATH1}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
            orders: {
              post: (option: { body: Methods_18h6bkn['post']['reqBody'], headers: Methods_18h6bkn['post']['reqHeaders'], config?: T | undefined }) =>
                fetch<Methods_18h6bkn['post']['resBody']>(prefix, `${prefix2}${PATH2}`, POST, option).json(),
              $post: (option: { body: Methods_18h6bkn['post']['reqBody'], headers: Methods_18h6bkn['post']['reqHeaders'], config?: T | undefined }) =>
                fetch<Methods_18h6bkn['post']['resBody']>(prefix, `${prefix2}${PATH2}`, POST, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH2}`,
            },
            payment_methods: {
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_i3lft1['get']['resBody']>(prefix, `${prefix2}${PATH3}`, GET, option).json(),
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_i3lft1['get']['resBody']>(prefix, `${prefix2}${PATH3}`, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH3}`,
            },
            prize_categories: {
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1k90ym3['get']['resBody']>(prefix, `${prefix2}${PATH4}`, GET, option).json(),
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1k90ym3['get']['resBody']>(prefix, `${prefix2}${PATH4}`, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH4}`,
            },
            prizes: {
              get: (option?: { headers?: Methods_155ooz['get']['reqHeaders'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_155ooz['get']['resBody']>(prefix, `${prefix2}${PATH5}`, GET, option).json(),
              $get: (option?: { headers?: Methods_155ooz['get']['reqHeaders'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_155ooz['get']['resBody']>(prefix, `${prefix2}${PATH5}`, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH5}`,
            },
            get: (option?: { query?: Methods_qpdg6l['get']['query'] | undefined, headers?: Methods_qpdg6l['get']['reqHeaders'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_qpdg6l['get']['resBody']>(prefix, prefix2, GET, option).json(),
            $get: (option?: { query?: Methods_qpdg6l['get']['query'] | undefined, headers?: Methods_qpdg6l['get']['reqHeaders'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_qpdg6l['get']['resBody']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_qpdg6l['get']['query'] } | undefined) =>
              `${prefix}${prefix2}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          };
        },
        by: {
          unique_name: {
            _uniqueName: (val4: string) => {
              const prefix4 = `${PATH6}/${val4}`;

              return {
                get: (option?: { headers?: Methods_jp7gs4['get']['reqHeaders'] | undefined, config?: T | undefined } | undefined) =>
                  fetch<Methods_jp7gs4['get']['resBody']>(prefix, prefix4, GET, option).json(),
                $get: (option?: { headers?: Methods_jp7gs4['get']['reqHeaders'] | undefined, config?: T | undefined } | undefined) =>
                  fetch<Methods_jp7gs4['get']['resBody']>(prefix, prefix4, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix4}`,
              };
            },
          },
        },
        get: (option?: { query?: Methods_10i7gxn['get']['query'] | undefined, headers?: Methods_10i7gxn['get']['reqHeaders'] | undefined, config?: T | undefined } | undefined) =>
          fetch<Methods_10i7gxn['get']['resBody']>(prefix, PATH0, GET, option).json(),
        $get: (option?: { query?: Methods_10i7gxn['get']['query'] | undefined, headers?: Methods_10i7gxn['get']['reqHeaders'] | undefined, config?: T | undefined } | undefined) =>
          fetch<Methods_10i7gxn['get']['resBody']>(prefix, PATH0, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_10i7gxn['get']['query'] } | undefined) =>
          `${prefix}${PATH0}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      gift_codes: {
        post: (option: { body: Methods_rtn983['post']['reqBody'], headers: Methods_rtn983['post']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_rtn983['post']['resBody']>(prefix, PATH7, POST, option).json(),
        $post: (option: { body: Methods_rtn983['post']['reqBody'], headers: Methods_rtn983['post']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_rtn983['post']['resBody']>(prefix, PATH7, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH7}`,
      },
      me: {
        areas: {
          post: (option: { body: Methods_lqx827['post']['reqBody'], headers: Methods_lqx827['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_lqx827['post']['resBody']>(prefix, PATH9, POST, option).json(),
          $post: (option: { body: Methods_lqx827['post']['reqBody'], headers: Methods_lqx827['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_lqx827['post']['resBody']>(prefix, PATH9, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH9}`,
        },
        beacons: {
          post: (option: { body: Methods_14pl3r8['post']['reqBody'], headers: Methods_14pl3r8['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_14pl3r8['post']['resBody']>(prefix, PATH10, POST, option).json(),
          $post: (option: { body: Methods_14pl3r8['post']['reqBody'], headers: Methods_14pl3r8['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_14pl3r8['post']['resBody']>(prefix, PATH10, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH10}`,
        },
        credits: {
          _cardSeqId: (val3: string) => {
            const prefix3 = `${PATH11}/${val3}`;

            return {
              delete: (option: { headers: Methods_u3w4jc['delete']['reqHeaders'], config?: T | undefined }) =>
                fetch(prefix, prefix3, DELETE, option).send(),
              $delete: (option: { headers: Methods_u3w4jc['delete']['reqHeaders'], config?: T | undefined }) =>
                fetch(prefix, prefix3, DELETE, option).send().then(r => r.body),
              $path: () => `${prefix}${prefix3}`,
            };
          },
          get: (option: { headers: Methods_ffqwfn['get']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_ffqwfn['get']['resBody']>(prefix, PATH11, GET, option).json(),
          $get: (option: { headers: Methods_ffqwfn['get']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_ffqwfn['get']['resBody']>(prefix, PATH11, GET, option).json().then(r => r.body),
          post: (option: { body: Methods_ffqwfn['post']['reqBody'], headers: Methods_ffqwfn['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_ffqwfn['post']['resBody']>(prefix, PATH11, POST, option).json(),
          $post: (option: { body: Methods_ffqwfn['post']['reqBody'], headers: Methods_ffqwfn['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_ffqwfn['post']['resBody']>(prefix, PATH11, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH11}`,
        },
        granted_prizes: {
          benefits: {
            _benefitPrizeId: (val4: string) => {
              const prefix4 = `${PATH13}/${val4}`;

              return {
                download: {
                  get: (option: { headers: Methods_95zgw7['get']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_95zgw7['get']['resBody']>(prefix, `${prefix4}${PATH14}`, GET, option).json(),
                  $get: (option: { headers: Methods_95zgw7['get']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_95zgw7['get']['resBody']>(prefix, `${prefix4}${PATH14}`, GET, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix4}${PATH14}`,
                },
              };
            },
          },
          prizes: {
            _prizeId: (val4: string) => {
              const prefix4 = `${PATH15}/${val4}`;

              return {
                download: {
                  get: (option: { headers: Methods_12oioyj['get']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_12oioyj['get']['resBody']>(prefix, `${prefix4}${PATH14}`, GET, option).json(),
                  $get: (option: { headers: Methods_12oioyj['get']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_12oioyj['get']['resBody']>(prefix, `${prefix4}${PATH14}`, GET, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix4}${PATH14}`,
                },
              };
            },
          },
          get: (option: { query: Methods_3ypo3e['get']['query'], headers: Methods_3ypo3e['get']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_3ypo3e['get']['resBody']>(prefix, PATH12, GET, option).json(),
          $get: (option: { query: Methods_3ypo3e['get']['query'], headers: Methods_3ypo3e['get']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_3ypo3e['get']['resBody']>(prefix, PATH12, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_3ypo3e['get']['query'] } | undefined) =>
            `${prefix}${PATH12}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        icons: {
          upload: {
            post: (option: { body: Methods_1c0gekd['post']['reqBody'], headers: Methods_1c0gekd['post']['reqHeaders'], config?: T | undefined }) =>
              fetch<Methods_1c0gekd['post']['resBody']>(prefix, PATH16, POST, option).json(),
            $post: (option: { body: Methods_1c0gekd['post']['reqBody'], headers: Methods_1c0gekd['post']['reqHeaders'], config?: T | undefined }) =>
              fetch<Methods_1c0gekd['post']['resBody']>(prefix, PATH16, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH16}`,
          },
        },
        infos: {
          get: (option: { headers: Methods_19tp65g['get']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_19tp65g['get']['resBody']>(prefix, PATH17, GET, option).json(),
          $get: (option: { headers: Methods_19tp65g['get']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_19tp65g['get']['resBody']>(prefix, PATH17, GET, option).json().then(r => r.body),
          put: (option: { body: Methods_19tp65g['put']['reqBody'], headers: Methods_19tp65g['put']['reqHeaders'], config?: T | undefined }) =>
            fetch(prefix, PATH17, PUT, option).send(),
          $put: (option: { body: Methods_19tp65g['put']['reqBody'], headers: Methods_19tp65g['put']['reqHeaders'], config?: T | undefined }) =>
            fetch(prefix, PATH17, PUT, option).send().then(r => r.body),
          patch: (option: { body: Methods_19tp65g['patch']['reqBody'], headers: Methods_19tp65g['patch']['reqHeaders'], config?: T | undefined }) =>
            fetch(prefix, PATH17, PATCH, option).send(),
          $patch: (option: { body: Methods_19tp65g['patch']['reqBody'], headers: Methods_19tp65g['patch']['reqHeaders'], config?: T | undefined }) =>
            fetch(prefix, PATH17, PATCH, option).send().then(r => r.body),
          $path: () => `${prefix}${PATH17}`,
        },
        ocodes: {
          post: (option: { body: Methods_ixueji['post']['reqBody'], headers: Methods_ixueji['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_ixueji['post']['resBody']>(prefix, PATH18, POST, option).json(),
          $post: (option: { body: Methods_ixueji['post']['reqBody'], headers: Methods_ixueji['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_ixueji['post']['resBody']>(prefix, PATH18, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH18}`,
        },
        prize_tickets: {
          _serial_code: (val3: string) => {
            const prefix3 = `${PATH19}/${val3}`;

            return {
              patch: (option: { headers: Methods_jnwdhc['patch']['reqHeaders'], config?: T | undefined }) =>
                fetch<Methods_jnwdhc['patch']['resBody']>(prefix, prefix3, PATCH, option).json(),
              $patch: (option: { headers: Methods_jnwdhc['patch']['reqHeaders'], config?: T | undefined }) =>
                fetch<Methods_jnwdhc['patch']['resBody']>(prefix, prefix3, PATCH, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix3}`,
            };
          },
          get: (option: { query?: Methods_rok7wn['get']['query'] | undefined, headers: Methods_rok7wn['get']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_rok7wn['get']['resBody']>(prefix, PATH19, GET, option).json(),
          $get: (option: { query?: Methods_rok7wn['get']['query'] | undefined, headers: Methods_rok7wn['get']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_rok7wn['get']['resBody']>(prefix, PATH19, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_rok7wn['get']['query'] } | undefined) =>
            `${prefix}${PATH19}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        get: (option: { headers: Methods_fqs2dy['get']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_fqs2dy['get']['resBody'], BasicHeaders, Methods_fqs2dy['get']['status']>(prefix, PATH8, GET, option).json(),
        $get: (option: { headers: Methods_fqs2dy['get']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_fqs2dy['get']['resBody'], BasicHeaders, Methods_fqs2dy['get']['status']>(prefix, PATH8, GET, option).json().then(r => r.body),
        delete: (option: { headers: Methods_fqs2dy['delete']['reqHeaders'], config?: T | undefined }) =>
          fetch<void, BasicHeaders, Methods_fqs2dy['delete']['status']>(prefix, PATH8, DELETE, option).send(),
        $delete: (option: { headers: Methods_fqs2dy['delete']['reqHeaders'], config?: T | undefined }) =>
          fetch<void, BasicHeaders, Methods_fqs2dy['delete']['status']>(prefix, PATH8, DELETE, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH8}`,
      },
      orders: {
        _orderId: (val2: string) => {
          const prefix2 = `${PATH20}/${val2}`;

          return {
            payments: {
              alipay: {
                post: (option: { body: Methods_1e8vwug['post']['reqBody'], headers: Methods_1e8vwug['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_1e8vwug['post']['resBody']>(prefix, `${prefix2}${PATH22}`, POST, option).json(),
                $post: (option: { body: Methods_1e8vwug['post']['reqBody'], headers: Methods_1e8vwug['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_1e8vwug['post']['resBody']>(prefix, `${prefix2}${PATH22}`, POST, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix2}${PATH22}`,
              },
              applepay: {
                post: (option: { body: Methods_16asjng['post']['reqBody'], headers: Methods_16asjng['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_16asjng['post']['resBody']>(prefix, `${prefix2}${PATH23}`, POST, option).text(),
                $post: (option: { body: Methods_16asjng['post']['reqBody'], headers: Methods_16asjng['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_16asjng['post']['resBody']>(prefix, `${prefix2}${PATH23}`, POST, option).text().then(r => r.body),
                $path: () => `${prefix}${prefix2}${PATH23}`,
              },
              carriers: {
                au: {
                  post: (option: { body: Methods_c5df96['post']['reqBody'], headers: Methods_c5df96['post']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_c5df96['post']['resBody']>(prefix, `${prefix2}${PATH24}`, POST, option).json(),
                  $post: (option: { body: Methods_c5df96['post']['reqBody'], headers: Methods_c5df96['post']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_c5df96['post']['resBody']>(prefix, `${prefix2}${PATH24}`, POST, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix2}${PATH24}`,
                },
                docomo: {
                  post: (option: { body: Methods_nf65lj['post']['reqBody'], headers: Methods_nf65lj['post']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_nf65lj['post']['resBody']>(prefix, `${prefix2}${PATH25}`, POST, option).json(),
                  $post: (option: { body: Methods_nf65lj['post']['reqBody'], headers: Methods_nf65lj['post']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_nf65lj['post']['resBody']>(prefix, `${prefix2}${PATH25}`, POST, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix2}${PATH25}`,
                },
                softbank: {
                  post: (option: { body: Methods_ouaef2['post']['reqBody'], headers: Methods_ouaef2['post']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_ouaef2['post']['resBody']>(prefix, `${prefix2}${PATH26}`, POST, option).json(),
                  $post: (option: { body: Methods_ouaef2['post']['reqBody'], headers: Methods_ouaef2['post']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_ouaef2['post']['resBody']>(prefix, `${prefix2}${PATH26}`, POST, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix2}${PATH26}`,
                },
              },
              credit: {
                $3ds2: {
                  post: (option: { body: Methods_1fmwd6u['post']['reqBody'], headers: Methods_1fmwd6u['post']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_1fmwd6u['post']['resBody']>(prefix, `${prefix2}${PATH28}`, POST, option).json(),
                  $post: (option: { body: Methods_1fmwd6u['post']['reqBody'], headers: Methods_1fmwd6u['post']['reqHeaders'], config?: T | undefined }) =>
                    fetch<Methods_1fmwd6u['post']['resBody']>(prefix, `${prefix2}${PATH28}`, POST, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix2}${PATH28}`,
                },
                post: (option: { body: Methods_1g1qew3['post']['reqBody'], headers: Methods_1g1qew3['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_1g1qew3['post']['resBody']>(prefix, `${prefix2}${PATH27}`, POST, option).json(),
                $post: (option: { body: Methods_1g1qew3['post']['reqBody'], headers: Methods_1g1qew3['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_1g1qew3['post']['resBody']>(prefix, `${prefix2}${PATH27}`, POST, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix2}${PATH27}`,
              },
              googlepay: {
                post: (option: { body: Methods_nvzj09['post']['reqBody'], headers: Methods_nvzj09['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_nvzj09['post']['resBody']>(prefix, `${prefix2}${PATH29}`, POST, option).text(),
                $post: (option: { body: Methods_nvzj09['post']['reqBody'], headers: Methods_nvzj09['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_nvzj09['post']['resBody']>(prefix, `${prefix2}${PATH29}`, POST, option).text().then(r => r.body),
                $path: () => `${prefix}${prefix2}${PATH29}`,
              },
              play_tickets: {
                post: (option: { body: Methods_801cq2['post']['reqBody'], headers: Methods_801cq2['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_801cq2['post']['resBody']>(prefix, `${prefix2}${PATH30}`, POST, option).json(),
                $post: (option: { body: Methods_801cq2['post']['reqBody'], headers: Methods_801cq2['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_801cq2['post']['resBody']>(prefix, `${prefix2}${PATH30}`, POST, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix2}${PATH30}`,
              },
              unionpay: {
                post: (option: { body: Methods_15ezvix['post']['reqBody'], headers: Methods_15ezvix['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_15ezvix['post']['resBody']>(prefix, `${prefix2}${PATH31}`, POST, option).json(),
                $post: (option: { body: Methods_15ezvix['post']['reqBody'], headers: Methods_15ezvix['post']['reqHeaders'], config?: T | undefined }) =>
                  fetch<Methods_15ezvix['post']['resBody']>(prefix, `${prefix2}${PATH31}`, POST, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix2}${PATH31}`,
              },
              post: (option: { body: Methods_15gem2t['post']['reqBody'], headers: Methods_15gem2t['post']['reqHeaders'], config?: T | undefined }) =>
                fetch<Methods_15gem2t['post']['resBody']>(prefix, `${prefix2}${PATH21}`, POST, option).json(),
              $post: (option: { body: Methods_15gem2t['post']['reqBody'], headers: Methods_15gem2t['post']['reqHeaders'], config?: T | undefined }) =>
                fetch<Methods_15gem2t['post']['resBody']>(prefix, `${prefix2}${PATH21}`, POST, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH21}`,
            },
            get: (option: { headers: Methods_uv94x9['get']['reqHeaders'], config?: T | undefined }) =>
              fetch<Methods_uv94x9['get']['resBody']>(prefix, prefix2, GET, option).json(),
            $get: (option: { headers: Methods_uv94x9['get']['reqHeaders'], config?: T | undefined }) =>
              fetch<Methods_uv94x9['get']['resBody']>(prefix, prefix2, GET, option).json().then(r => r.body),
            delete: (option: { headers: Methods_uv94x9['delete']['reqHeaders'], config?: T | undefined }) =>
              fetch(prefix, prefix2, DELETE, option).send(),
            $delete: (option: { headers: Methods_uv94x9['delete']['reqHeaders'], config?: T | undefined }) =>
              fetch(prefix, prefix2, DELETE, option).send().then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          };
        },
        get: (option: { query?: Methods_1p1uf81['get']['query'] | undefined, headers: Methods_1p1uf81['get']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_1p1uf81['get']['resBody']>(prefix, PATH20, GET, option).json(),
        $get: (option: { query?: Methods_1p1uf81['get']['query'] | undefined, headers: Methods_1p1uf81['get']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_1p1uf81['get']['resBody']>(prefix, PATH20, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1p1uf81['get']['query'] } | undefined) =>
          `${prefix}${PATH20}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      payments: {
        apple_pay_session: {
          post: (option: { body: Methods_1n5lpfq['post']['reqBody'], headers: Methods_1n5lpfq['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_1n5lpfq['post']['resBody']>(prefix, PATH32, POST, option).json(),
          $post: (option: { body: Methods_1n5lpfq['post']['reqBody'], headers: Methods_1n5lpfq['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_1n5lpfq['post']['resBody']>(prefix, PATH32, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH32}`,
        },
      },
      pickups: {
        get: (option: { headers: Methods_a3nfz1['get']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_a3nfz1['get']['resBody']>(prefix, PATH33, GET, option).json(),
        $get: (option: { headers: Methods_a3nfz1['get']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_a3nfz1['get']['resBody']>(prefix, PATH33, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH33}`,
      },
      play_tickets: {
        get: (option: { headers: Methods_1r1cra4['get']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_1r1cra4['get']['resBody']>(prefix, PATH34, GET, option).json(),
        $get: (option: { headers: Methods_1r1cra4['get']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_1r1cra4['get']['resBody']>(prefix, PATH34, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH34}`,
      },
      redeem_tickets: {
        get: (option: { headers: Methods_ei2tgm['get']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_ei2tgm['get']['resBody']>(prefix, PATH35, GET, option).json(),
        $get: (option: { headers: Methods_ei2tgm['get']['reqHeaders'], config?: T | undefined }) =>
          fetch<Methods_ei2tgm['get']['resBody']>(prefix, PATH35, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH35}`,
      },
      users: {
        signup: {
          post: (option: { headers: Methods_1rwgf4h['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_1rwgf4h['post']['resBody']>(prefix, PATH36, POST, option).json(),
          $post: (option: { headers: Methods_1rwgf4h['post']['reqHeaders'], config?: T | undefined }) =>
            fetch<Methods_1rwgf4h['post']['resBody']>(prefix, PATH36, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH36}`,
        },
      },
    },
  };
};

export type ApiInstance = ReturnType<typeof api>;
export default api;
